import { MInput } from '@Components/Base';
import {
  Checkbox,
  CheckboxOptionType,
  CheckboxProps,
  Col,
  Flex,
  Row,
} from 'antd';
import { useEffect, useState } from 'react';

interface RenderDropdownCheckboxProps {
  options: CheckboxOptionType<string>[];
  labelOption: string;
  onChange?: (value: string[]) => void;
  checkedOptions?: string[];
}

const CheckboxGroup = Checkbox.Group;

const RenderDropdownCheckbox: React.FC<RenderDropdownCheckboxProps> = ({
  options,
  labelOption,
  onChange,
  checkedOptions = [],
}) => {
  const [optionsCheckbox, setOptionsCheckbox] = useState<
    CheckboxOptionType<string>[]
  >([]);
  const [searchValue, setSearchValue] = useState('');
  const [checkedList, setCheckedList] = useState<Array<string>>(checkedOptions);

  const checkAll = options.length === checkedList.length;
  const indeterminate =
    checkedList.length > 0 && checkedList.length < options.length;

  const handleClearAll = (): void => {
    const listToSet: string[] = [];

    onChange?.(listToSet);
    setCheckedList([]);
  };

  const onChangeList = (list: string[]): void => {
    setCheckedList(list);
    onChange?.(list);
  };

  const onCheckAllChange: CheckboxProps['onChange'] = (e) => {
    const listToSet = e.target.checked
      ? options.map((option) => option.value)
      : [];
    setCheckedList(listToSet);
    onChange?.(listToSet);
  };

  useEffect(() => {
    const optionsToSet = searchValue
      ? options.filter((option) => {
          const label = option?.label as string;
          return label?.toLowerCase().includes(searchValue.toLowerCase());
        })
      : options;

    setOptionsCheckbox(optionsToSet);
  }, [searchValue, options]);

  return (
    <div className="mselect-dropdown">
      <div className="mselect-dropdown-label dropdown-checkbox">
        <span>{labelOption}</span>
        <Flex className="mselect-dropdown-clearAll" onClick={handleClearAll}>
          Clear All
        </Flex>
      </div>
      <Row>
        <Col span={24}>
          <Flex
            className="mselect-checkbox-content"
            vertical
            wrap="nowrap"
            gap={14}
          >
            <MInput
              className="mselect-search-input"
              searchInput
              onChange={(event) => {
                setSearchValue(event.target.value);
              }}
              placeholder="Search"
            />
            <Checkbox
              className="mselect-checkbox-select-all"
              onChange={onCheckAllChange}
              indeterminate={indeterminate}
              checked={checkAll}
            >
              Select all
            </Checkbox>
            <CheckboxGroup
              className="mselect-checkbox-options"
              name="options"
              options={optionsCheckbox}
              value={checkedList}
              onChange={onChangeList}
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};

export default RenderDropdownCheckbox;
